const FilterNameConfig = {
  type: "Workflow Type",
  name: "Run Name",
  status: "Status",
};

export default FilterNameConfig;